import { Fragment } from "react"
import { useRoutes } from "react-router-dom"
import MainLayout from "../layouts/Main"
import { lazy, Suspense } from "react"
import Guard from "../components/Guard"
const Home = lazy(() => import("../pages/Home"))    
const CreateTicketList = lazy(() => import("../pages/CreateTicketList"))
const TicketsList = lazy(() => import("../pages/TicketsList"))
const Auth = lazy(() => import("../pages/Auth"))
const MyProfile = lazy(() => import("../pages/MyProfile"))

const lazyLoad = (Component) => (
    <Suspense fallback={<div className="h-full w-full animate-pulse bg-customGray"></div>}>
        <Component />
    </Suspense>
)

const Router = ()=>{
    const routes = useRoutes([
      {
        path: "/",
        element: <MainLayout />,
        children: [
          {
            path: "",
            element: lazyLoad(Home),
          },
          {
            path: "create-ticket-list",
            element: lazyLoad(CreateTicketList),
          },
          {
            path: "my-tickets",
            element: lazyLoad(TicketsList),
          },
          {
            path: "auth/:type",
            element: lazyLoad(Auth),
          },
          {
            element: <Guard />,
            children: [
              {
                path: "my-profile",
                element: lazyLoad(MyProfile),
              },
            ],
          },
          {
            path: "edit-ticket-list",
            element: lazyLoad(CreateTicketList),
          },
        ],
      },
      {
        path: "*",
        element: <div>404</div>,
      },
    ]);
    return <Fragment>
        {routes}
    </Fragment>
}

export default Router;